import React from 'react';
import PropTypes from 'prop-types';
import {
  fieldNames, formatFieldName, formatFieldValue, formatCustomFieldValue,
} from '../../utils/imports';

const ExpandedRow = ({ entry, type }) => {
  // Check if the entry has errors
  const erroredAttributes = entry.errors.map((error) => error.attribute.toLowerCase());
  // Check if the entry has custom fields
  const isCustomFields = ['site', 'visit', 'contact'].includes(type) && entry.custom_fields && Object.keys(entry.custom_fields).length > 0;
  return (
    <div className="px-4 pt-7.5 pb-8.5">
      <div className="space-y-3" data-testid="regular-attributes">
        {fieldNames(type).map((fieldName) => (
          <div key={fieldName} className={`flex pl-2 ${erroredAttributes.includes(fieldName.toLowerCase()) ? 'bg-vamos-red bg-opacity-50' : ''} gap-3`} data-testid={`import-regular-attributes-for-${fieldName}`}>
            <div className="w-1/3 md:w-1/4 font-bold" data-testid="import-regular-attributes-label">{formatFieldName(fieldName, type)}</div>
            <div data-testid="import-regular-attributes-value">{erroredAttributes.includes(fieldName.toLowerCase()) ? entry[fieldName] : formatFieldValue(fieldName, entry[fieldName])}</div>
          </div>
        ))}
        {isCustomFields && (
          <div className="flex flex-col pt-3 pl-2">
            <h3 className="text-xl font-bold border-b border-vamos-blue-gray">Custom fields</h3>
            <div className="py-4 space-y-3" data-testid="custom-fields">
              {Object.entries(entry.custom_fields).map(([fieldName, value]) => (
                <div key={fieldName} className={`flex gap-3 ${erroredAttributes.includes(fieldName.toLowerCase()) ? 'bg-vamos-red bg-opacity-50' : ''}`} data-testid={`import-custom-fields-for-${fieldName}`}>
                  <p className="w-1/3 md:w-1/4 font-bold" data-testid="import-custom-fields-label">{formatFieldName(fieldName, type)}</p>
                  {/* on error: show raw imported value; on success: show value formatted (for now dates normalized to MM/DD/YYYY) */}
                  <div data-testid="import-custom-fields-value">{erroredAttributes.includes(fieldName.toLowerCase()) ? value : formatCustomFieldValue(value)}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ExpandedRow.propTypes = {
  entry: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default ExpandedRow;
